export default __webpack_public_path__ + "static/media/image-ph-study-main-1-n-w@2x.e49b85d0.png";